export default "__VITE_ASSET__Rcub6JbT__"